import type React from 'react';

interface McCardLightIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function McCardLightIcon({ size = 24, ...props }: McCardLightIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_8664_25220)">
        <path
          d="M2.62496 0.800049H39.375C40.8241 0.800049 42 1.94527 42 3.35769V27.6437C42 29.0548 40.8241 30.2 39.375 30.2H2.62496C1.17465 30.2002 0 29.0548 0 27.6438V3.35769C0 1.94527 1.17594 0.800049 2.62496 0.800049Z"
          fill="white"
        />
        <path d="M24.8163 8.89722H17.6411V22.1039H24.8163V8.89722Z" fill="#FF5F00" />
        <path
          d="M18.095 15.5001C18.095 12.8168 19.3251 10.4368 21.2157 8.89676C19.8262 7.77676 18.0722 7.1001 16.1589 7.1001C11.6259 7.1001 7.9586 10.8568 7.9586 15.5001C7.9586 20.1434 11.6259 23.9001 16.1589 23.9001C18.0722 23.9001 19.8262 23.2234 21.2157 22.1034C19.3251 20.5868 18.095 18.1834 18.095 15.5001Z"
          fill="#EB001B"
        />
        <path
          d="M34.4962 15.5001C34.4962 20.1434 30.8288 23.9001 26.2959 23.9001C24.3825 23.9001 22.6286 23.2234 21.2391 22.1034C23.1525 20.5634 24.3597 18.1834 24.3597 15.5001C24.3597 12.8168 23.1297 10.4368 21.2391 8.89676C22.6286 7.77676 24.3825 7.1001 26.2959 7.1001C30.8288 7.1001 34.4962 10.8801 34.4962 15.5001Z"
          fill="#F79E1B"
        />
      </g>
      <rect
        x="0.3"
        y="1.10005"
        width="41.4"
        height="28.8"
        rx="3.7"
        stroke="#CDCFD2"
        strokeWidth="0.6"
        strokeDasharray="3 3"
      />
      <defs>
        <clipPath id="clip0_8664_25220">
          <rect y="0.800049" width="42" height="29.4" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
